import { render, staticRenderFns } from "./ProductsBlock.vue?vue&type=template&id=4ef51ad5&scoped=true&"
import script from "./ProductsBlock.vue?vue&type=script&lang=js&"
export * from "./ProductsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProductsBlock.vue?vue&type=style&index=0&id=4ef51ad5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef51ad5",
  null
  
)

export default component.exports